import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import { jsx } from 'react/jsx-runtime';

const FadeIn = props => {
  const {
    children,
    delay
  } = props;
  return /*#__PURE__*/jsx(AnimatePresence, {
    children: /*#__PURE__*/jsx(motion.div, {
      initial: {
        y: 50,
        opacity: 0
      },
      animate: {
        y: 0,
        opacity: 1
      },
      transition: {
        delay,
        duration: 0.3,
        ease: 'easeOut'
      },
      exit: {
        opacity: 0
      },
      children: children
    })
  });
};
FadeIn.defaultProps = {
  children: '',
  delay: 0
};
FadeIn.propTypes = {
  children: PropTypes.node,
  delay: PropTypes.number
};
var FadeIn$1 = FadeIn;

export { FadeIn$1 as default };
//# sourceMappingURL=FadeIn.js.map
